module.exports = __webpack_public_path__ + "static/marker-bf14e0691766c3d76931af6f5b1f85a8.mp4";